import axios from 'axios';

export default {
  state: {
    types: [],
    subjects: [],
    themes: [],
    testTable: []
  },
  getters: {
    getTypes: e => e.types,
    getSubjects: e => e.subjects,
    getThemes: e => e.themes,
    getTestTable: e => e.testTable
  },
  mutations: {
    setTypes(state, types) {
      state.types = types;
    },
    setSubjects(state, subjects) {
      state.subjects = subjects;
    },
    setThemes(state, themes) {
      state.themes = themes;
    },
    setTestTable(state, testTable) {
      state.testTable = testTable;
    }
  },
  actions: {
    async find({ commit }, params) {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API}/test/find`,
          params
        );
        return res.data;
      } catch (e) {
        commit('setError', e.response.data.message);
        console.log(e.response);
        throw e;
      }
    },
    async types({ commit, getters }) {
      try {
        if (getters.getTypes.length < 1) {
          const data = await axios.get(`${process.env.VUE_APP_API}/types`);
          commit('setTypes', data.data);
        }
      } catch (e) {
        commit('setError', e.response.data.message);
        console.log(e);
        throw e;
      }
    },
    async subjects({ commit, getters }) {
      try {
        if (getters.getSubjects.length < 1) {
          const data = await axios.get(`${process.env.VUE_APP_API}/subjects`);
          commit('setSubjects', data.data);
        }
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async themes({ commit, getters }) {
      try {
        if (getters.getThemes.length < 1) {
          const data = await axios.get(`${process.env.VUE_APP_API}/themes`);
          commit('setThemes', data.data);
        }
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async begin({ commit }, params) {
      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API}/user-exam/create`,
          params
        );
        console.log(data);
        return data;
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async index({ commit }) {
      try {
        const result = await axios.get(`${process.env.VUE_APP_API}/user-exam`);
        console.log(result.data);
        return result.data;
        // commit('setTestTable', result.data)
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async exam(_, id) {
      const result = await axios.get(
        `${process.env.VUE_APP_API}/exam?id=${id}`
      );
      return result.data;
    },
    async examView(_, id) {
      const result = await axios.get(
        `${process.env.VUE_APP_API}/user-exam/view?id=${id}`
      );
      return result.data;
    },
    async examDetail(_, id) {
      const result = await axios.get(
        `${process.env.VUE_APP_API}/user-exam/detail?id=${id}`
      );
      console.log('detail', result.data);
      return result.data;
    },
    async finish({ commit }, { id, answers }) {
      try {
        const {
          data
        } = await axios.post(
          `${process.env.VUE_APP_API}/exam/finish?id=${id}`,
          { answers }
        );
        return data;
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    }
  }
};
